import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";
import SideMenu from "../components/SideMenu";

// Importando os dois arquivos JSON
import ebookDataBrasil from "../utils/ebooks.json";
import ebookDataLatam from "../utils/ebooksLatam.json";

function Leituras() {
    const { t } = useTranslation();

    // Pegando o produto ativo do localStorage
    const [produtoAtivo, setProdutoAtivo] = useState(() => localStorage.getItem("produto_ativo") || "");

    // Definindo qual array de ebooks renderizar baseado no produto ativo
    const ebooksParaExibir = produtoAtivo === "latam"
        ? ebookDataLatam.ebooks
        : ebookDataBrasil.ebooks;

    return (
        <div id="wrapper" style={{ backgroundColor: "#043A5E" }}>
            <SideMenu />

            <div
                id="page-wrapper"
                className="pb-5"
                style={{ backgroundColor: "#FCFCFD" }}
            >
                <Navbar />

                <div
                    className="pl-2 mt-4 mb-3 custom-normal"
                    style={{ fontSize: "38px", fontWeight: "600" }}
                >
                    {t("leituras.title")}
                </div>

                <div
                    className="bg-white shadow-sm p-4"
                    style={{ borderRadius: "1rem", minHeight: "100vh" }}
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        {ebooksParaExibir.map((ebook) => (
                            <ul key={ebook.link}>
                                <li>
                                    <a
                                        href={ebook.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ fontSize: "20px" }}
                                    >
                                        {ebook.title}
                                    </a>
                                </li>
                            </ul>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Leituras;